/**
 * @type {DataProvider}
 */
var BrowserSource = require('core/utils/browser');

module.exports = {
  provides: 'url',

  getter: [
    /**
     * @return {Array}
     */
    function() {
      return BrowserSource.getUrl();
    },
  ],
};
